import { IconsTypes } from "../../types";
import { ComponentContainer } from "../container";
import { ComponentAppbarProps } from "./types";
import * as styles from "./styles";

export const ComponentAppbar = ({
  title,
  className = "",
  onReturn,
  onOpen,
  actions,
  css,
}: ComponentAppbarProps) => {
  return (
    <header css={[styles.appbar, css]} className={`appbar  ${className}`}>
      <ComponentContainer css={styles.container}>
        <>
          {onReturn && (
            <button
              onClick={onReturn}
              className={`appbar_button appbar-return`}
              css={styles.buttonIcon}
            >
              <i className={`${"fas fa-arrow-left" as IconsTypes}`} />
            </button>
          )}
          <h1 className={`appbar_title`} css={styles.title}>
            {title}
          </h1>
          <div className={`appbar_actions`} css={styles.actionsContainer}>
            {actions &&
              actions.map((action, index) => {
                return (
                  <button
                    key={index}
                    onClick={action.action}
                    className={`appbar_button appbar_action`}
                    css={styles.buttonIcon}
                  >
                    <i className={action.icon} />
                  </button>
                );
              })}
            {onOpen && (
              <button
                onClick={onOpen}
                className={`appbar_button appbar-menu `}
                css={styles.menu}
              >
                <i className={`${"fas fa-bars" as IconsTypes}`} />
              </button>
            )}
          </div>
        </>
      </ComponentContainer>
    </header>
  );
};
